export default "__VITE_ASSET__C59A5frl__"